<template>
  <div class="cadfm-container-horizontal">

            <DashboardWidgets v-if="$route.params.view == 'DashboardWidgets'" :lang="lang.Dashboard.DashboardWidgets"></DashboardWidgets>
            <DashboardTable v-if="$route.params.view == 'DashboardTable'"></DashboardTable>
 </div>
</template>

<script>
import DashboardWidgets from '@/components/Dashboard/Views/DashboardWidgets'
import DashboardTable from '@/components/Dashboard/Views/DashboardTable'

//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components:{
    DashboardWidgets,
    DashboardTable
  },
  props:{
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "d",
      basicView: "DashboardWidgets",
    }
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue